import {
  call,
  put,
  takeLatest,
} from 'redux-saga/effects'
import {
  acceptAction,
  rejectAction,
} from '@Infowijs-eng/component-library/modules/reduxPromiseHelpers'
import axios from 'axios'
import { serviceEndpoints } from '@Infowijs-eng/component-library/modules'
import actionTypes from '../../action-types'
import awaitAccessToken from '../../modules/awaitAccessToken'
import setUserGroupRelations from '../../actions/user/setUserGroupRelations'

const onFetchUserGroupRelations = function* onFetchUserGroupRelations() {
  yield takeLatest(actionTypes.USER.USER_GROUP_RELATIONS_FETCH, function* onFetchUserGroupRelationsSaga(action) {
    const accessToken = yield call(awaitAccessToken)

    const {
      payload: { userId },
    } = action

    let response
    try {
      response = yield call(axios, {
        url: `${serviceEndpoints.users}/${userId}/user-groups/relations`,
        params: {
          include: 'userGroup',
        },
        method: 'GET',
        headers: {
          Authorization: `Bearer ${accessToken}`,
          'X-Infowijs-Client': 'nl.infowijs.admin',
          'Content-Type': 'application/vnd.infowijs.v1+json',
          Accept: 'application/vnd.infowijs.v1+json',
        },
      })
    } catch (e) {
      rejectAction(action, e.response.data && e.response.data.errors)
      return
    }

    yield put(setUserGroupRelations(userId, response.data.data || [], response.data.meta, response.data.included || []))

    acceptAction(action, response.data.data || [])
  })
}

export default onFetchUserGroupRelations
